import React, { lazy } from "react";
import HomeScreen from "./Components/HomeScreen/HomeScreen";
import FAQ from "./Components/Features/FAQ/Faq";
import PrivacyPolicy from "./Components/Features/Privacy/Privacy";
import TermsAndConditions from "./Components/Features/Terms/Terms";
import AbstractSubmissionGuideline from "./Components/Features/Abstract/Abstract";
import TravelInformation from "./Components/Features/Travel/Travel";
import Speakers from "./Components/Speakers/Speakers";
import ContactUs from "./Components/ContactUs/ContactUs";
import SignIn from "./Components/SignIn/SignIn";
import SignUp from "./Components/SignUp/SignUp";
import ConferenceSchedule from "./Components/Program/Program";
import PastPrograms from "./Components/Program/PastPrograms";
import AppPosterList from "./Components/ApprovedPosterList/AppPosterList";
import Arcives from "./Components/Archives/Archives";
import ProfileRegistration from "./Components/ProfileRegistration/ProfileRegistration";
import AbstractSubmission from "./Components/AbstractSubmission/AbstractSubmission";
import WorkshopRegistration from "./Components/WorkshopReg/WorkshopReg";
import RegComplete from "./Components/RegistrationComplete/RegComplete";
import ForgotPassword from "./Components/ForgotPassword/ForgotPassword";
import ProtectedRoute from "./Components/ProtectedRoutes";
import PaymentProcessingPage from "./Components/PaymentProcessingPage/PaymentProcessingPage";
import MessagesComponent from "./Components/Messages/Messages";

const VerifyEmail = lazy(() =>
  import("./Components/SignupVerifyEmail/SignupVerifyEmail")
);
const ProfileComponent = lazy(() => import("./Components/Profile/Profile"));

export const routes = [
  { path: "/", element: <HomeScreen /> },
  { path: "/faq", element: <FAQ /> },
  { path: "/privacy", element: <PrivacyPolicy /> },
  { path: "/terms", element: <TermsAndConditions /> },
  { path: "/abstract", element: <AbstractSubmissionGuideline /> },
  { path: "/travel", element: <TravelInformation /> },
  { path: "/contact", element: <ContactUs /> },
  { path: "/login", element: <SignIn /> },
  { path: "/program", element: <ConferenceSchedule /> },
  { path: "/past-programs", element: <PastPrograms /> },
  { path: "/signup", element: <SignUp /> },
  {
    path: "/profilereg",
    element: (
      <ProtectedRoute>
        <ProfileRegistration />
      </ProtectedRoute>
    ),
  },
  {
    path: "/abstractsubmission",
    element: (
      <ProtectedRoute>
        <AbstractSubmission />
      </ProtectedRoute>
    ),
  },
  { path: "/events", element: <WorkshopRegistration /> },
  {
    path: "/profile",
    element: (
      <ProtectedRoute>
        <ProfileComponent />
      </ProtectedRoute>
    ),
  },
  {
    path: "/regcomplete",
    element: (
      <ProtectedRoute>
        <RegComplete />
      </ProtectedRoute>
    ),
  },
  {
    path: "/payment-processing",
    element: (
      <ProtectedRoute>
        <PaymentProcessingPage />
      </ProtectedRoute>
    ),
  },
  { path: "/forgotpass", element: <ForgotPassword /> },
  { path: "/verify-email", element: <VerifyEmail /> },
];
